import { generateId } from '@freelancer/datastore/testing/helpers';
import type { PartialSearchArticle } from './partial-search-articles.model';

export interface GeneratePartialSearchArticleOptions {
  readonly id?: number;
  readonly title?: string;
  readonly canonicalUrl?: string;
  readonly categoryName?: string;
  readonly seoUrl?: string;
}

export function generatePartialSearchArticleObject({
  id = generateId(),
  title,
  canonicalUrl,
  categoryName = 'General',
  seoUrl,
}: GeneratePartialSearchArticleOptions): PartialSearchArticle {
  return {
    id,
    title: title ?? `Article ${id}`,
    canonicalUrl: canonicalUrl
      ? // Copied from transformPartialSearchArticle
        canonicalUrl.replace(/^\//, '').split('/').length === 4
        ? canonicalUrl
        : `/support/employer/${categoryName.toLowerCase()}/${seoUrl ?? `article-${id}`}`
      : `/support/employer/general/article-${id}`,
  };
}

export function generatePartialSearchArticleObjects(
  articles: readonly GeneratePartialSearchArticleOptions[],
): readonly PartialSearchArticle[] {
  return articles.map(article => generatePartialSearchArticleObject(article));
}
